<section class="pb-container pb-my-6" [ngClass]="dynamicClass" [attr.id]="dynamicId ? dynamicId : null" *ngIf="clerks?.length>0">
  <div class="pb-divide-y pb-divide-warm-grey-60 pb-border-t pb-border-b pb-border-warm-grey-60">
    <div class="pb-flex pb-row pb-bg-warm-grey-10">
      <div class="pb-w-1/3 pb-p-[6px] pb-text-[13px] pb-font-bold pb-border-x pb-border-warm-grey-60">{{rendering?.fields?.NameLabel?.value}}</div>
      <div class="pb-w-2/3 pb-p-[6px] pb-text-[13px] pb-font-bold pb-border-r pb-border-warm-grey-60">{{rendering?.fields?.PositionLabel?.value}}</div>
    </div>
    <div class="pb-flex pb pb-p-3-row" *ngFor="let item of clerks">
      <div class="pb-w-1/3 pb-p-[6px] pb-text-[10px] pb-border-x pb-border-warm-grey-60">{{item?.FullName}}</div>
      <div class="pb-w-2/3 pb-p-[6px] pb-text-[10px] pb-border-r pb-border-warm-grey-60">{{item?.Role}}</div>
    </div>
  </div>
</section>
